import { CustomColumn } from '../../../types/customColumn';
import { FilteredPurchase } from '../../../types/purchases/BasePurchase';
import { formatCurrency } from '../../../utils/formatCurrency';

const STATUS_LABELS: Record<string, string> = {
  DTE_PENDING: 'Pendiente de envío a Hacienda',
  DRAFT_CANCELLED: 'Cancelada',
};

export const purchaseHistoryColumns: CustomColumn<FilteredPurchase>[] = [
  {
    Header: 'Estado',
    accessor: 'status',
    customCell: ({ value }) => (
      <span
        className={`text-sm font-medium ${
          value === 'DRAFT_CANCELLED'
            ? 'text-danger'
            : 'text-black dark:text-white'
        }`}
      >
        {STATUS_LABELS[String(value)] ?? String(value).replaceAll('_', ' ')}
      </span>
    ),
  },
  /**
   * 📄 Documento
   */
  {
    Header: 'Documento',
    accessor: 'documentType',
    customCell: ({ row }) => (
      <div className="min-w-[180px]">
        <div className="font-medium text-black dark:text-white">
          {row.original.documentType || '—'}
        </div>

        <div className="text-gray-500 dark:text-gray-400 text-xs">
          {row.original.documentNumber || 'Sin número'}
        </div>
      </div>
    ),
  },

  /**
   * 🏢 Proveedor
   */
  {
    Header: 'Proveedor',
    accessor: 'supplierName',
    customCell: ({ value }) => (
      <div className="min-w-[220px] max-w-[280px]">
        <p
          className="
            whitespace-normal
            break-words
            font-medium
            leading-6
            text-black
            dark:text-white
          "
        >
          {value || 'Proveedor no definido'}
        </p>
      </div>
    ),
  },

  /**
   * 📅 Fecha documento
   */
  {
    Header: 'Fecha',
    accessor: 'purchaseDate',
    customCell: ({ value }) => (
      <span className="text-gray-700 dark:text-gray-300 whitespace-nowrap text-sm">
        {value || '—'}
      </span>
    ),
  },

  /**
   * 💰 Total compra
   */
  {
    Header: 'Total',
    accessor: 'totalAmount',
    showStatus: true,
    customCell: ({ value }) => (
      <div className="min-w-[140px]">
        <span className="font-bold text-primary">
          ${formatCurrency(value || 0)}
        </span>
      </div>
    ),
  },
];
